import React, {useState} from 'react'
import Modal from '../Modal/Modal'
import './_imageViewer.scss'

const ImageViewer = ({url, alt = ''}) => {
  const [showModal, setShowModal] = useState(false)

  const handleOpenModal = () => {
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setShowModal(false)
  }

  return (
    <div className="image-viewer-wrapper">
      <img src={url} alt={alt} className="review-image" data-testid="thumbnail-image" />
      <button className="image-viewer-button" onClick={handleOpenModal} aria-label="Expand image" type="button">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M14 7.33333V2H8.66667L10.86 4.19333L4.19333 10.86L2 8.66667V14H7.33333L5.14 11.8067L11.8067 5.14L14 7.33333Z"
            fill="#66A5E7"
          />
        </svg>
      </button>

      <Modal
        showModal={showModal}
        onCloseModal={handleCloseModal}
        title=""
        content={
          <div className="image-modal-content">
            <img src={url} alt={alt} className="modal-full-image" data-testid="modal-image" />
          </div>
        }
        showPrimaryButton={false}
        showSecondaryButton={false}
        classNameWrapper="flex items-center justify-center"
      />
    </div>
  )
}

export default ImageViewer
